import { PAGE_CONFIG } from "../utils/constants";

import { PRODUCT_TYPES } from "../../services/Partners/constants";
import { getUserInfoFromLocalStorage } from "../services/Fetch";

export const getProductTypes = () => {
  const userState = getUserInfoFromLocalStorage();

  let pageConfig: any = PAGE_CONFIG["default"];

  if (userState?.organizationID && PAGE_CONFIG?.[userState?.organizationID])
    pageConfig = PAGE_CONFIG[userState?.organizationID];

  return PRODUCT_TYPES.filter((p) =>
    pageConfig?.global?.productTypes?.includes(p.value)
  );
};
